import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { styled } from 'baseui';
import { Block } from 'baseui/block';
import DOMPurify from 'dompurify';
const HTMLBlock = styled(Block, ({
  $theme
}) => ({
  maxHeight: '500px',
  overflow: 'auto',
  padding: $theme.sizing.scale300,
  marginRight: $theme.sizing.scale400,
  backgroundColor: $theme.colors.backgroundPrimary,
  border: `1px solid ${$theme.colors.contentSecondary}`,
  borderRadius: $theme.sizing.scale100,
  fontFamily: 'Uber Move'
}));
const HTMLRender = ({
  src
}: {
  src: string;
}) => {
  const sanitizedData = DOMPurify.sanitize(src);
  if (!sanitizedData) return null;
  return <HTMLBlock data-testid="html" dir="auto">
      {ReactHtmlParser(sanitizedData)}
    </HTMLBlock>;
};
export default HTMLRender;